import { ArcElement, Chart, ChartData, ChartOptions, Legend, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { connect, ConnectedProps } from "react-redux";

import { StoreState } from "store";
import { resolveColor } from "utils/commonFunctions";

const connector = connect((state: StoreState) => ({
    theme: state.themeReducer.theme,
}));

interface ChartProps {
    chartData: ChartData<"doughnut">;
    horizontalStacking?: boolean;
    verticalStacking?: boolean;
}

type Props = ChartProps & ConnectedProps<typeof connector>;

Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DoughnutChartWidget = (props: Props): JSX.Element => {
    const getChartOptions = (textColor: string): ChartOptions<"doughnut"> => {
        return {
            elements: {
                arc: {
                    borderWidth: 0,
                },
            },
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: "right",
                    align: "start",
                    labels: {
                        usePointStyle: true,
                        color: textColor,
                    },
                },
                tooltip: {
                    enabled: true,
                },
                datalabels: {
                    display: false,
                },
            },
            maintainAspectRatio: false,
        };
    };

    return <Doughnut data={props.chartData} options={getChartOptions(resolveColor("--app-chart-textColor"))} />;
};
export default connector(DoughnutChartWidget);
